// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__FtSH7","primary":"Button_primary__1E8ax","outline":"Button_outline__yFKff"};